
export default {
  name: 'ArrowDown',

  /**
     * Icon - Arrow_down
     * This is an arrow down icon with the bode blue color
     */

  props: {
    height: {
      type: String,
      default: '10px',
    },
    width: {
      type: String,
      default: '16px',
    },
  },
};
